// mock t function for i18next scanner to pick up
const t = (x: string) => x

export enum IxMeldungStatusFilter {
    eAlle = 0,
    eOffen = 1,
    eNeu = 2,
    eInBearbeitung = 3,
    eErledigt = 4,
    eStorniert = 5,
}

export const IxMeldungStatusFilterLabels: {[k: string]: string} = {
    [IxMeldungStatusFilter.eAlle]: t('meldung:enum.IxMeldungStatusFilter.eAlle'),
    [IxMeldungStatusFilter.eOffen]: t('meldung:enum.IxMeldungStatusFilter.eOffen'),
    [IxMeldungStatusFilter.eNeu]: t('meldung:enum.IxMeldungStatusFilter.eNeu'),
    [IxMeldungStatusFilter.eInBearbeitung]: t('meldung:enum.IxMeldungStatusFilter.eInBearbeitung'),
    [IxMeldungStatusFilter.eErledigt]: t('meldung:enum.IxMeldungStatusFilter.eErledigt'),
    [IxMeldungStatusFilter.eStorniert]: t('meldung:enum.IxMeldungStatusFilter.eStorniert'),
}

export const ixMeldungStatusFilterToOpts = (t: Function, settings: any) => {
    const opts = []

    for(let x in IxMeldungStatusFilter) {
        if (!isNaN(Number(x))) { continue }


        opts.push({
            name: t(IxMeldungStatusFilterLabels[IxMeldungStatusFilter[x as keyof typeof IxMeldungStatusFilter]]),
            value: IxMeldungStatusFilter[x as keyof typeof IxMeldungStatusFilter],
        })
    }

    return opts
}
